import { preview } from './preview';
import { jobsite } from './builder';
import { ShippingLocationModeCode } from '../../../../models/shipping-location-mode.model';
import { OneClickConfig } from '@ordersnproducts/modules/one-click-order/models/one-click-config';

export const pickUp: OneClickConfig = {
  preview: preview,
  builder: {
    [ShippingLocationModeCode.Jobsite]: jobsite,
  },
};
